import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { orderBy } from 'natural-orderby';
import { truncate } from 'underscore.string';
import SpringLoader from '../../../../components/SpringLoader/SpringLoader.js';
import ToastUtil from '../../../../components/ToastNotification/ToastUtil';
import AlertService from '../../../../components/SweetAlert';
import { config } from '../../../../config/index';
import placeholderImage from '../../../../assets/images/placeholder.jpg';
import Searchbar from '../../../../components/Searchbar';
const { API_URL } = config;

const ClientManagement = ({ history }) => {
  const token = localStorage.getItem('token');
  const [clients, setClients] = useState([]);

  const [filteredClients, setFilteredClients] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [loading, setLoading] = useState(true);

  const checkboxHandler = (e) => {
    if (e.target.checked) {
      let updatedSelectedIds = [...selectedIds];

      updatedSelectedIds.push(parseInt(e.target.value));
      setSelectedIds(updatedSelectedIds);
    } else {
      let updatedSelectedIds = [...selectedIds].filter(
        (id) => id !== parseInt(e.target.value)
      );

      setSelectedIds(updatedSelectedIds);
    }
  };

  const checkboxAllOn = (e) => {
    if (e.target.checked) {
      let admin_ids = filteredClients.map((admin) => admin.id);
      setSelectedIds(admin_ids);
    } else {
      setSelectedIds([]);
    }
  };

  const searchHandler = (e) => {
    let filtered = [...clients].filter((client) => {
      // let name = `${client.first_name} ${client.last_name}`
      return (
        client.name.toUpperCase().indexOf(e.target.value.toUpperCase()) > -1
      );
    });

    setFilteredClients(filtered);
  };

  const deleteClient = async (id) => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to delete this Client?'
      )
    ) {
      const url = `${API_URL}/client/${id}`;

      try {
        let response = await fetch(url, {
          mode: 'cors',
          method: 'DELETE',
          withCredentials: true,
          headers: {
            Authorization: token,
          },
        });

        let data = await response.json();

        if (response.ok) {
          ToastUtil.success('Client successfully deleted!');
          window.location.reload();
        } else {
          ToastUtil.error(data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const deleteSelectedHandler = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to delete these Clients?'
      )
    ) {
      var failed = [];
      for (let id of selectedIds) {
        const url = `${API_URL}/client/${id}`;

        let response = await fetch(url, {
          mode: 'cors',
          method: 'DELETE',
          withCredentials: true,
          headers: {
            Authorization: token,
          },
        });

        let data = await response.json();

        if (!response.ok) {
          failed.push(id);
        }
      }

      if (failed.length > 0) {
        return ToastUtil.error('Failed to delete clients that have data!');
      }

      ToastUtil.success('Clients successfully deleted!');
      window.location.reload();
    }
  };

  const fetchClients = async () => {
    setLoading(true);
    try {
      let url = `${API_URL}/client`;
      let token = localStorage.getItem('token');

      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      if (response.ok) {
        let data = await response.json();
        let clients = data.data;

        // Sort by 'updatedAt' in descending order
        let sorted = orderBy(clients, ['updatedAt'], ['desc']);

        setClients(sorted);
        setFilteredClients(JSON.parse(JSON.stringify(sorted)));
      } else {
        console.log(response.message);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchClients();
  }, []);

  return (
    <div
      className="container-fluid"
      style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
    >
      <div className="border-bottom pb-2 py-4 d-flex align-items-center">
        <h6 className="flex-grow-1 pt-4 text-brand">Client Management</h6>
        <div>
          <button
            onClick={() => history.push('/clients/add')}
            className="btn btn-outline-brand ms-3 mt-2 adjust-fs adjust-shadow"
            style={{ width: '200px' }}
          >
            Add New
          </button>
        </div>
      </div>
      <div className="d-flex flex-row align-items-center py-3">
        <h6 className="flex-grow-1">Client ({filteredClients.length})</h6>
        <Searchbar
          search={(e) => searchHandler(e)}
          placeholder="Search client"
        />
      </div>
      <div className="table-responsive rounded shadow bg-white">
        <table className="table table-borderless mb-0">
          <thead className="border-bottom">
            <tr>
              <th className="py-3 text-muted fw-normal">
                <div className="form-check">
                  <input
                    className="form-check-input position-static"
                    onChange={checkboxAllOn}
                    type="checkbox"
                  />
                </div>
              </th>
              {selectedIds.length > 0 ? (
                <React.Fragment>
                  <th className="py-3 text-muted fw-normal">Client</th>
                  <th className="py-3 text-muted fw-normal"></th>
                  <th className="py-3 text-muted fw-normal"></th>
                  <th className="py-3 text-muted fw-normal"></th>
                  <th className="py-3 text-danger fw-normal">
                    <div
                      style={{ cursor: 'pointer' }}
                      onClick={deleteSelectedHandler}
                    >
                      Delete
                    </div>
                  </th>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <th className="py-3 text-muted fw-normal">Client</th>
                  <th className="py-3 text-muted fw-normal">Client Contact</th>
                  <th className="py-3 text-muted fw-normal">Email</th>
                  <th className="py-3 text-muted fw-normal">Status</th>
                  <th className="py-3 text-muted fw-normal"></th>
                </React.Fragment>
              )}
            </tr>
          </thead>
          <tbody>
            {filteredClients.length > 0 ? (
              filteredClients.map((client) => (
                <tr key={client.id} className="border-bottom">
                  <td>
                    <div className="form-check">
                      <input
                        className="form-check-input position-static"
                        type="checkbox"
                        checked={selectedIds.some((id) => id === client.id)}
                        value={client.id}
                        onChange={checkboxHandler}
                      />
                    </div>
                  </td>
                  <td className="d-flex align-items-center">
                    <img
                      src={client.photo ? client.photo : placeholderImage}
                      alt="default"
                      className="rounded-circle border me-3"
                      style={{ height: '30px', width: '30px' }}
                    />
                    <Link
                      to={`/clients/client/${client.id}`}
                      style={{ color: 'inherit', textDecoration: 'none' }}
                    >
                      <strong className="text-muted">{client.name}</strong>
                    </Link>
                  </td>
                  <td className="text-muted">
                    {client.manager_first_name} {client.manager_last_name}
                  </td>
                  <td className="text-muted">{client.email}</td>
                  <td>
                    <div className="d-flex flex-row align-items-center">
                      <span className="badge rounded-pill bg-success me-1 p-2">
                        {client.active ? 'Active' : 'Inactive'}
                      </span>
                    </div>
                  </td>
                  <td className="text-center">
                    <div
                      style={{ cursor: 'pointer' }}
                      className="dropdown custom-dropdown"
                    >
                      <button
                        className="btn dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i
                          className="fas fa-ellipsis-h adjust-fs"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        ></i>
                      </button>
                      <div
                        className="dropdown-menu dropdown-menu-right"
                        style={{ width: '150px' }}
                      >
                        <Link
                          to={`/clients/client/${client.id}/edit`}
                          style={{ cursor: 'pointer' }}
                          className="dropdown-item border-bottom pb-2 adjust-fs"
                        >
                          Edit
                        </Link>
                        <div
                          onClick={() => deleteClient(client.id)}
                          style={{ cursor: 'pointer' }}
                          className="dropdown-item pt-2 adjust-fs"
                        >
                          Delete
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  {loading ? (
                    <div className="springloader-holder">
                      <SpringLoader></SpringLoader>
                    </div>
                  ) : (
                    <div className="text-center text-muted my-3 pb-4">
                      <i>No results</i>
                    </div>
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ClientManagement;
